import { Menu, styled, Typography, useTheme } from "@mui/material";
import { createElement, Dispatch, memo, MouseEvent, SetStateAction, useRef, useState } from "react";
import { StyledListItemButton, StyledListItemIcon, StyledListItemText } from "components/Reports/components";
import shortid from "shortid";
import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { IOSSwitch } from "components/Input/switch";
import CustomizeIcon from "assets/icons/CustomizeIcon";
import SubItemCloseIcon from "assets/icons/SubItemCloseIcon";
import SubItemOpenIcon from "assets/icons/SubItemOpenIcon";
import { factorPatternType } from "components/SalaryDocumnet";

const EditColumnsContainer = styled("div")({
  width: "316px",
});
const MiddleComponent = styled("div")({
  maxHeight: "250px",
  overflowY: "scroll",
});

const TitleContainer = styled("div")({
  height: "44px",
  display: "flex",
  alignItems: "center",
  flexDirection: "row-reverse",
});
const salaryNavItems = [
  {
    title: "آیتم های حقوقی",
    state: "itemsOfSalary",
  },
  {
    title: "کسورات",
    state: "deductions",
  },
  {
    title: "اضافات",
    state: "additions",
  },
];
//@ts-ignore
const getRightPosition = (items, container, activeIndex: number) => {
  try {
    const itemRight = items.current[activeIndex]?.getBoundingClientRect().right;
    // @ts-ignore
    const containerRight = container.current?.getBoundingClientRect().right;

    // @ts-ignore
    return parseInt(containerRight - itemRight);
  } catch {
    return 0;
  }
};

interface ThumbInterface {
  rightPosition: number;
}

const Thumb = styled("div")<ThumbInterface>(({ theme, rightPosition }) => ({
  position: "absolute",
  right: rightPosition || 4,
  backgroundColor: "white",
  top: "3px",
  borderRadius: "4px",
  zIndex: 1,
  height: "34px",
  width: "95px",
  transition: "all 0.3s",
}));

const NavigationParent = styled("div")(({ theme }) => ({
  padding: "0 8px",
  marginBottom: "8px",
}));
const NavigationContainer = styled("div")(({ theme }) => ({
  padding: "4px",
  height: "40px",
  position: "relative",
  borderRadius: "4px",
  backgroundColor: "#F3F4F5",
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
}));
const NavigationItem = styled("div")(({ theme }) => ({
  display: "flex",
  height: "30px",
  width: "95px",
  alignItems: "center",
  cursor: "pointer",
  justifyContent: "space-evenly",
  zIndex: 2,
}));

interface ItemInterface {
  paddingRight: number;
}

const CustomizeItemContainer = styled("div")<ItemInterface>(({ theme, paddingRight }) => ({
  backgroundColor: "white",
  paddingRight: paddingRight,
  paddingLeft: "10px",
  height: "44px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: 4,
  margin: "0 10px",
  marginBottom: "11px",
  "&:hover": {
    border: "1px solid #ABBACC",
  },
}));

const RightItem = styled("div")({
  display: "flex",
  alignItems: "center",
});

const checked = (selected: accountTypeType[], data: accountTypeType) => {
  return selected.findIndex((item) => data.id === item.id) !== -1;
};
// @ts-ignore
const isOpen = (data: accountTypeType, selected: accountTypeType[]) => {
  if (data && data.childs) {
    //@ts-ignore
    for (let i = 0; i < data.childs.length; i++) {
      const child = data.childs[i];

      if (checked(selected, child)) return true;

      if (isOpen(child, selected)) return true;
    }
  }

  return false;
};

const ListSubItem = memo(
  ({
    data,
    paddingRight,
    handleSelect,
    selected,
  }: {
    data: accountTypeType;
    paddingRight: number;
    handleSelect: (account: accountTypeType) => void;
    selected: accountTypeType[];
  }) => {
    const [open, setOpen] = useState(isOpen(data, selected));

    const childPaddingRight = paddingRight + 16;

    const handleClick = () => {
      setOpen(!open);
    };
    if (data.childs && data.childs.length !== 0) {
      return (
        <>
          <StyledListItemButton
            disableRipple
            active={open}
            onClick={handleClick}
            paddingRight={childPaddingRight}
          >
            <StyledListItemIcon>{open ? <SubItemCloseIcon /> : <SubItemOpenIcon />}</StyledListItemIcon>
            <StyledListItemText>
              <Typography variant="body2">{data.title}</Typography>
            </StyledListItemText>
          </StyledListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {data.childs &&
                data.childs.map((item) => (
                  <ListSubItem
                    selected={selected}
                    handleSelect={handleSelect}
                    paddingRight={childPaddingRight}
                    data={item}
                    key={shortid.generate()}
                  />
                ))}
            </List>
          </Collapse>
        </>
      );
    }
    return (
      <CustomizeItemContainer key={shortid.generate()} paddingRight={childPaddingRight}>
        <IOSSwitch onChange={() => handleSelect(data)} defaultChecked={checked(selected, data)} />
        <RightItem>
          <Typography variant="body2" mr={1} textAlign="right">
            {data.title}
          </Typography>
          <CustomizeIcon />
        </RightItem>
      </CustomizeItemContainer>
    );
  }
);

const Navigation = ({ setPattern }: { setPattern: Dispatch<SetStateAction<factorPatternType>> }) => {
  const itemsRef = useRef<HTMLDivElement[]>([]);

  const containerRef = useRef(createElement("div"));

  const theme = useTheme();

  const [activeTab, setActiveTab] = useState(0);

  return (
    // @ts-ignore
    <NavigationContainer ref={containerRef}>
      <Thumb rightPosition={getRightPosition(itemsRef, containerRef, activeTab)} />
      {salaryNavItems.map((item, key) => {
        // @ts-ignore
        return (
          <NavigationItem
            // @ts-ignore
            ref={(el) => el && (itemsRef.current[key] = el)}
            key={shortid.generate()}
            onClick={() => {
              setActiveTab(key);
              // @ts-ignore
              setPattern(item.state);
            }}
          >
            <Typography
              textAlign="center"
              color={activeTab === key ? "primary" : theme.palette.text.disabled}
              fontSize={12}
            >
              {item.title}
            </Typography>
          </NavigationItem>
        );
      })}
    </NavigationContainer>
  );
};

const SalaryDocumentSetting = ({
  anchorEl,
  handleClose,
  accountingList,
  setSalaryDocument,
  selected,
  handleSelect,
}: {
  anchorEl: null | HTMLElement;
  handleClose: () => void;
  selected: accountTypeType[];
  accountingList: accountTypeType[];
  setSalaryDocument: Dispatch<SetStateAction<factorPatternType>>;
  handleSelect: (account: accountTypeType) => void;
}) => {
  const open = Boolean(anchorEl);

  const initialPaddingRight = 16;

  return (
    <Menu
      onClick={(e: MouseEvent<HTMLDivElement>) => {
        return e.stopPropagation();
      }}
      id="demo-positioned-menu"
      aria-labelledby="demo-positioned-button"
      anchorEl={anchorEl}
      open={open}
      sx={{
        left: "55px",
        top: "0px",
        "& div": {
          "& ul": {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      }}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <EditColumnsContainer>
        <TitleContainer>
          <Typography variant="body2" mr={1} textAlign="right" color="#ABBACC">
            :ویرایش ستون ها
          </Typography>
        </TitleContainer>
        <NavigationParent>
          <Navigation setPattern={setSalaryDocument} />
        </NavigationParent>
        <MiddleComponent>
          {accountingList &&
            accountingList.map((item) => {
              return (
                <ListSubItem
                  selected={selected}
                  paddingRight={initialPaddingRight}
                  handleSelect={handleSelect}
                  data={item}
                  key={shortid.generate()}
                />
              );
            })}
        </MiddleComponent>
      </EditColumnsContainer>
    </Menu>
  );
};

export default SalaryDocumentSetting;
